import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";
import { colors } from "../../../design/tokens";

export function AppStoreRankingsSEOText() {
  const isCompactView = useIsCompactView();

  return (
    <div className="w-full bg-dark-surface-primary relative overflow-hidden">
      {/* Content container */}
      <div
        className={`relative z-10 max-w-[1300px] mx-auto ${
          isCompactView ? "px-4 py-12" : "px-8 py-16"
        }`}
      >
        {/* Text content */}
        <div className="space-y-6 text-justify">
          <p
            className={`${
              isCompactView ? "text-[16px]" : "text-[17px]"
            } ${colors.text.secondary} leading-[1.7]`}
          >
            Discover top <strong className={colors.text.primary}>iOS and Android apps</strong> across
            every category. Browse real-time <strong className={colors.text.primary}>app store
            rankings</strong> for free, paid, and top-grossing apps in over 150 countries. Find
            trending mobile apps, analyze competitor apps, and track what's popular in Games,
            Social, Productivity, Entertainment, and more.
          </p>
          <p
            className={`${
              isCompactView ? "text-[16px]" : "text-[17px]"
            } ${colors.text.secondary} leading-[1.7]`}
          >
            Use these insights to get inspired and <strong className={colors.text.primary}>build
            your own mobile app</strong> with Darvin's AI-powered app development platform — no
            coding experience required.
          </p>
        </div>
      </div>
    </div>
  );
}
